import React from 'react'
import PropTypes from 'prop-types'

import {
  FeatureCardContainer,
  IconColumn,
  TextColumn,
  TitleText,
  Copy,
  Link,
  LinkPlaceholder,
} from './styles'

const FeatureCard = ({ icon, title, copy, linkCopy, linkUrl }) => (
  <FeatureCardContainer>
    <IconColumn>{icon}</IconColumn>
    <TextColumn>
      <TitleText>{title}</TitleText>
      <Copy>{copy}</Copy>
      {linkCopy && linkUrl ? (
        <Link target="_blank" rel="noopener noreferrer" href={linkUrl}>
          {linkCopy}
        </Link>
      ) : (
        <LinkPlaceholder />
      )}
    </TextColumn>
  </FeatureCardContainer>
)

export default FeatureCard

FeatureCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  linkCopy: PropTypes.string,
  linkUrl: PropTypes.string,
}
